import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { SocialExportGetConnectionStateDto } from '@mi-front/api-v2';
import { Box, Stack, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { ConnectionListItem } from './ConnectionListItem';
import { connectionsManageMessages as messages } from './connections-manage-messages';
import { PlatformConnectFactory } from './platforms/PlatformConnectFactory';

type Props = {
  platform: SocialPlatform;
  connections: SocialExportGetConnectionStateDto[];
  selectedConnectionId: string | null;
  onSelect: (connectionId: string) => void;
};

/**
 * Left navigation panel listing all connections for the current platform.
 */
export function ConnectionsListPanel({
  platform,
  connections,
  selectedConnectionId,
  onSelect,
}: Props) {
  return (
    <Box
      sx={{
        p: 2,
        borderRadius: 1,
        border: 1,
        borderColor: 'divider',
        bgcolor: 'background.paper',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        height: '100%',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
        <Typography variant="subtitle2">
          <FormattedMessage {...messages.connectedAccounts} />
        </Typography>
        <PlatformConnectFactory platform={platform} />
      </Box>

      <Stack spacing={1.5}>
        {connections.map((connection) => (
          <ConnectionListItem
            key={connection.id}
            connection={connection}
            selected={connection.id === selectedConnectionId}
            onSelect={onSelect}
          />
        ))}
      </Stack>
    </Box>
  );
}
